package addedittravelagent

interface AddEditTravelAgentNavigation {
    data class EditProposal(val proposalId: String) : AddEditTravelAgentNavigation
    data class EditItinerary(val itineraryId: String) : AddEditTravelAgentNavigation
}